// ===========================================
// Public legal text hook
// ===========================================
//
// A school's Terms & Conditions, Privacy Policy and Cookie Policy from the PUBLIC endpoint (no
// login). Used by the public legal pages and the invitation's create-account page (#442 D1c).
// A signed-in surface reads the authenticated `useLegalSettings` instead.

import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../services/api';

export interface PublicLegalData {
  schoolName: string;
  termsOfService: string | null;
  privacyPolicy: string | null;
  cookiePolicy: string | null;
}

export function usePublicLegal(schoolSlug: string | null | undefined, enabled = true) {
  return useQuery({
    queryKey: ['public-legal', schoolSlug],
    queryFn: async () => {
      const res = await apiClient.get<{ status: string; data: PublicLegalData }>(
        `/public/schools/${schoolSlug}/legal`
      );
      return res.data;
    },
    enabled: enabled && Boolean(schoolSlug),
  });
}
